// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2w1Z_","consentsList":"PatientConsents_consentsList__8XYxu","consentsListEmpty":"PatientConsents_consentsListEmpty__1Ocro"};